// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardActivity_wrapper__pSmkx","card":"DashboardActivity_card__bfR8A","image":"DashboardActivity_image__Xt3BH"};